module.exports = __webpack_public_path__ + "static/29-5ceb785ed901701cc58f8f8e50a60764.jpg";